import React from 'react';

export const ShareIcon = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="inherit"
  >
    <path
      d="M9.3 7.5C9.79705 7.5 10.2 7.90295 10.2 8.4C10.2 8.86156 9.85256 9.24196 9.40496 9.29394L9.3 9.3H7.5C6.00883 9.3 4.8 10.5088 4.8 12C4.8 13.4379 5.92403 14.6133 7.34136 14.6954L7.5 14.7H9.3C9.79705 14.7 10.2 15.1029 10.2 15.6C10.2 16.0615 9.85256 16.4419 9.40496 16.494L9.3 16.5H7.5C5.01472 16.5 3 14.4853 3 12C3 9.58012 4.91008 7.60636 7.3048 7.50416L7.5 7.5H9.3ZM16.5 7.5C18.9853 7.5 21 9.51472 21 12C21 14.4199 19.0899 16.3936 16.6952 16.4959L16.5 16.5H14.7C14.2029 16.5 13.8 16.0971 13.8 15.6C13.8 15.1385 14.1474 14.758 14.5951 14.706L14.7 14.7H16.5C17.9912 14.7 19.2 13.4912 19.2 12C19.2 10.5621 18.076 9.38671 16.6587 9.30458L16.5 9.3H14.7C14.2029 9.3 13.8 8.89705 13.8 8.4C13.8 7.93844 14.1474 7.55804 14.5951 7.50606L14.7 7.5H16.5ZM7.5 11.1H16.5C16.9971 11.1 17.4 11.5029 17.4 12C17.4 12.4615 17.0526 12.842 16.6049 12.894L16.5 12.9H7.5C7.00295 12.9 6.6 12.4971 6.6 12C6.6 11.5385 6.94744 11.158 7.39504 11.106L7.5 11.1Z"
      fill={fill || 'inherit'}
    />
  </svg>
);
